// Computer opponents in rated play. Each level is a player of its own (id `bot-<level>`) with a
// Glicko rating per variant, so it settles where it really plays. These are the starting guesses.

/** Ratings each level starts from in a variant it hasn't played yet (levels 1-5). */
export const BOT_START_RATINGS: readonly number[] = [800, 1100, 1450, 1800, 2100];
/** A firmer deviation than a new player's, so one upset doesn't swing a bot by hundreds. */
export const BOT_START_RD = 150;
/** How long you wait alone in the queue before a rated computer game is offered. */
export const RATED_BOT_AFTER_MS = 15_000;

export const BOT_LEVELS = [1, 2, 3, 4, 5] as const;

export const botId = (level: number) => `bot-${level}`;

/** The level of a bot player id, or null for people. */
export function botLevelOf(playerId: string | null | undefined): number | null {
  const m = playerId ? /^bot-([1-5])$/.exec(playerId) : null;
  return m ? Number(m[1]) : null;
}
